import { render, staticRenderFns } from "./CheckoutDetails.vue?vue&type=template&id=6229e74f&"
import script from "./CheckoutDetails.vue?vue&type=script&lang=js&"
export * from "./CheckoutDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports